// extracted by mini-css-extract-plugin
export default {"container":"ActivityHeader_container__abtzu","active":"ActivityHeader_active__uTro3","in-active":"ActivityHeader_in-active__jI4kz","row":"ActivityHeader_row__aLZL5"};